import { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";

export default function Reset() {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error("La contraseña debe tener al menos 8 caracteres.");
    if (password !== confirm) return toast.error("Las contraseñas no coinciden.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Contraseña actualizada");
      navigate("/acceso");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Nueva contraseña" subtitle="Introduzca su nueva contraseña de acceso."
      footer={<Link to="/acceso" style={{ color: "var(--burgundy)", textDecoration: "none", fontWeight: 600 }}>Volver a acceso</Link>}>
      <form onSubmit={submit} data-testid="reset-form">
        <label className="ddp-label">Nueva contraseña</label>
        <input type="password" className="ddp-input" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" required />
        <label className="ddp-label" style={{ marginTop: 16 }}>Repita la contraseña</label>
        <input type="password" className="ddp-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm" required />
        <button type="submit" disabled={loading} data-testid="reset-submit" className="ddp-btn ddp-btn-primary" style={{ width: "100%", marginTop: 24 }}>
          {loading ? "Guardando…" : "Guardar contraseña"}
        </button>
      </form>
    </AuthShell>
  );
}
